<div class="container-modal-history">
  <button (click)="closeModal()" class="close-button">
    <img src="assets/icons/closeBlack.svg" alt="" />
  </button>

  <div style="display: flex; flex-direction: column; flex: 1; gap: 10px">
    <h2>Status do relato - Ocorrência {{ denounce._id }}</h2>
    <div class="row ocurrence-headers container-user-information">
      <div class="col-4">
        <label>USUÁRIO</label>
        <p class="text-l">{{ cutString(denounce.user_id) }}</p>
      </div>
      <div class="col">
        <label>SITUAÇÃO</label>
        <p class="text-l">{{ denounce.complainer_type }}</p>
      </div>
    </div>
    <div class="line-c"></div>
    <div class="status-container-step">
      <div
        *ngFor="let sublista of listStatus; let i = index"
        class="status"
        id="status-{{ i }}"
      >
        <div class="container-elipse">
          <div class="elipse">{{ i + 1 }}</div>
          <div class="line-b"></div>
        </div>
        <div>
          <div
            class="update-status"
            *ngFor="let objeto of sublista; let j = index"
          >
            <h3 *ngIf="j == 0">{{ objeto.status.main }}</h3>
            <div class="information-status">
              <p>{{ formatarData(objeto.created_at) }}</p>
              <p class="destaque">{{ objeto.status.sub }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
